import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  IconButton,
  Select,
  MenuItem,
  Menu,
  Stack,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import ArrowDown from "../../assets/icons/ArrowDown.svg";
import React, { useState, useEffect } from "react";
import EditButton from "../../assets/icons/EditButton.svg";
import ViewButton from "../../assets/icons/ViewButton.svg";
import CalanderActive from "../../assets/icons/CalanderActive.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { DateEditCalendar } from "../CommonComponent/DateEditCalendar";
import { useLocation, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import GenerateDefectId from "../../utils/GenerateDefectId";
import noData from "../../assets/images/Group 688.png";
import {
  getDefectsList,
  isUpdateSuccessDefectsDetailsList,
} from "../../redux/actions/defectsAction";
import { TOTALLIMIT } from "../../utils/localStorage";
import { toast } from "react-toastify";

const DefectsContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { DefectsOpen, categoryDefectsdata } = location?.state || {};

  const isLoading = useSelector((state) => state?.user?.isLoading);

  const userData = useSelector((state) => state?.user?.userData);

  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );

  const [Defect, setDefect] = useState("");
  const [DefectType, setDefectType] = useState("");
  const [DefectsRowData, setDefectsRowData] = useState("");

  const [startDate, setStartDate] = useState(
    moment(userData?.createdAt).format("DD MMM, YYYY")
  );
  const [endDate, setEndDate] = useState(moment().format("DD MMM, YYYY"));
  const [anchorEl, setAnchorEl] = useState();
  const [anchorElEnd, setAnchorElEnd] = useState();
  const open = Boolean(anchorEl);
  const openEnd = Boolean(anchorElEnd);
  const [isPaginationLimit, setIsPaginationLimit] = useState(10);

  const [VesselName, setVesselName] = useState("");
  const [Department, setDepartment] = useState("");
  const [categoryDefect, setCategoryDefect] = useState(
    categoryDefectsdata ? categoryDefectsdata : ""
  );
  console.log("categoryDefect", categoryDefect);
  const [Status, setStatus] = useState(
    DefectsOpen === null ? "" : DefectsOpen ? DefectsOpen : "open"
  );

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleChangecategoryDefect = (event) => {
    setCategoryDefect(event.target.value);
  };
  const handleChangeDepartment = (event) => {
    setDepartment(event.target.value);
  };

  const handleChangeVesselName = (event) => {
    setVesselName(event.target.value);
  };

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleClick = (event) => {
    setAnchorElEnd(null);
    setAnchorEl(event.currentTarget);
  };

  const handleClickEnd = (event) => {
    setAnchorEl(null);
    setAnchorElEnd(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElEnd(null);
    setAnchorEl(null);
  };

  const handleCloseEnd = () => {
    setAnchorElEnd(null);
    setAnchorEl(null);
  };

  const handleSaveDateStart = (value) => {
    const formattedStartDate = moment(value, "YYYY-MM-DD").format(
      "DD MMM, YYYY"
    );
    setStartDate(formattedStartDate);
  };

  const handleSaveDateEnd = (value) => {
    const formattedEndDate = moment(value, "YYYY-MM-DD").format("DD MMM, YYYY");
    setEndDate(formattedEndDate);
  };

  const handleChangeDefect = (event) => {
    setDefect(event.target.value);
  };

  const handleChange = (event) => {
    setDefectType(event.target.value);
  };

  const DEFECT_REPORT_CHECKBOX_DATA = [
    {
      id: 1,
      value: "Main Engine",
      checked: false,
    },
    {
      id: 2,
      value: "Auxiliary Engines",
      checked: false,
    },
    {
      id: 3,
      value: "Maneuvering Equipment",
      checked: false,
    },
    {
      id: 4,
      value: "Hull & Tanks",
      checked: false,
    },
    {
      id: 5,
      value: "Winches/fixed and loose lifting gears",
      checked: false,
    },
    {
      id: 6,
      value: "Crane",
      checked: false,
    },
    {
      id: 7,
      value: "Mooring system",
      checked: false,
    },
    {
      id: 8,
      value: "Pumping system",
      checked: false,
    },
    {
      id: 9,
      value: "DP Equipment",
      checked: false,
    },
    {
      id: 10,
      value: "Navigation Equipment",
      checked: false,
    },
    {
      id: 11,
      value: "Communication Equipment",
      checked: false,
    },
    {
      id: 12,
      value: "Air compressor system",
      checked: false,
    },
    {
      id: 13,
      value: "Hotel / Galley / Accommodation",
      checked: false,
    },
    {
      id: 14,
      value: "Electrical/Electronic system",
      checked: false,
    },
    {
      id: 15,
      value: "Safety equipment",
      checked: false,
    },
    {
      id: 16,
      value: "Separators",
      checked: false,
    },
    {
      id: 17,
      value: "RO/Water Maker",
      checked: false,
    },
    {
      id: 18,
      value: "Sewage treatment plant",
      checked: false,
    },
    {
      id: 19,
      value: "Others",
      checked: false,
    },
  ];

  const formatChecklistId = (
    vesselName,
    departmentName,
    checklistType,
    displayId
  ) => {
    const vesselPrefix = vesselName?.slice(0, 3).toUpperCase() || "XXX";
    const departmentPrefix = departmentName?.charAt(0) || "X";
    const checklistTypePrefix = checklistType?.charAt(0) || "X";
    const year = new Date().getFullYear() || "YYYY";
    const formattedDisplayId = String(displayId).padStart(3, "0") || "000";

    return `${vesselPrefix}/${departmentPrefix}/${year}/${checklistTypePrefix}${formattedDisplayId}`;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const offset = currentPage - 1;
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    if (moment(endDate).isSameOrAfter(startDate)) {
      dispatch(
        getDefectsList({
          vessel_id: userData?.vessel_id ? userData?.vessel_id : VesselName,
          department_id: Department,
          offset: offset,
          limit: isPaginationLimit,
          category_defetct: encodeURIComponent(categoryDefect),
          defect_report_status: Status,
          startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
          endDate: moment(endDate)
            .add(23, "hours") // Add 0 hours
            .add(59, "minutes") // Add 0 minutes
            .add(0, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );
    } else {
      toast.error("End date cannot be before start date");
    }
  }, [
    userData?.vessel_id,
    VesselName,
    Department,
    Status,
    startDate,
    endDate,
    offset,
    isPaginationLimit,
    categoryDefect,
  ]);
  useEffect(() => {
    dispatch(isUpdateSuccessDefectsDetailsList(false));
  }, []);

  const hasPermission = (userPermissions, screenName) => {
    const permission = userPermissions?.find(
      (permission) =>
        permission?.screen?.name === screenName && permission?.screen?.active
    );

    if (permission?.active) {
      if (permission) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const defectstData = useSelector((state) => state?.defects?.defectstData);
  const defectstPaginationData = useSelector(
    (state) => state?.defects?.defectstPaginationData
  );

  console.log(DefectsOpen, 69);
  return (
    <Paper
      sx={{
        width: "auto",
        height: "auto",
        overflow: "auto",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px",
          overflow: "auto",
          width: "auto",
          "&::-webkit-scrollbar": {
            width: "5px",
            height: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#20724E",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#E5F1EB",
          },
        }}
      >
        <Box sx={{ width: "auto" }}>
          <Typography
            // onClick={() => {
            //   navigate("/defects/editdefectdetails");
            // }}
            sx={{ ml: 2, fontSize: "18px", fontWeight: 600, color: "#212121" }}
          >
            Defects
          </Typography>
          {defectstData.length >= 50 && (
            <Typography
              variant="body2"
              sx={{
                ml: 2,
                color: "#B5B5C3",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              More than 50+ new Defect
            </Typography>
          )}
        </Box>
        <Box sx={{ display: "flex" }}>
          {userData?.role?.name === "VESSEL_ADMIN" ||
          userData?.vessel_id !== null ? (
            ""
          ) : (
            <Select
              value={VesselName}
              onChange={handleChangeVesselName}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              IconComponent={() => (
                <Box
                  sx={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="Custom Icon"
                    width="18"
                    height="24"
                  />
                </Box>
              )}
              sx={{
                height: "37px",
                width: "11rem",
                color: "#20724E",
                fontWeight: "bold",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#E5F1EB",
                mr: 2,
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value="">Vessel Name</MenuItem>
              {vesselMasterData?.map((row) => (
                <MenuItem value={row?.id}>{row?.name}</MenuItem>
              ))}
            </Select>
          )}
          <Select
            value={Department}
            onChange={handleChangeDepartment}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            IconComponent={() => (
              <Box
                sx={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={ArrowDown} alt="Custom Icon" width="18" height="24" />
              </Box>
            )}
            sx={{
              height: "37px",
              width: "11rem",
              color: "#20724E",
              fontWeight: "bold",
              borderRadius: "10px",
              border: "none",
              backgroundColor: "#E5F1EB",
              mr: 2,
              "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                border: "1px solid #E5F1EB",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
          >
            <MenuItem value="">Department</MenuItem>
            {departmentMasterData?.map((row) => (
              <MenuItem value={row?.id}>{row?.name}</MenuItem>
            ))}
          </Select>
          <Select
            value={categoryDefect}
            onChange={handleChangecategoryDefect}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            IconComponent={() => (
              <Box
                sx={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={ArrowDown} alt="Custom Icon" width="18" height="24" />
              </Box>
            )}
            sx={{
              height: "37px",
              width: "14rem",
              color: "#20724E",
              fontWeight: "bold",
              borderRadius: "10px",
              border: "none",
              backgroundColor: "#E5F1EB",
              mr: 2,
              "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                border: "1px solid #E5F1EB",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
          >
            <MenuItem value="">Category Of Defect</MenuItem>
            {DEFECT_REPORT_CHECKBOX_DATA?.map((row) => (
              <MenuItem value={row?.value}>{row?.value}</MenuItem>
            ))}
          </Select>
          <Select
            value={Status}
            onChange={handleChangeStatus}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            IconComponent={() => (
              <Box
                sx={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={ArrowDown} alt="Custom Icon" width="16" height="24" />
              </Box>
            )}
            sx={{
              height: "37px",
              width: "9rem",
              color: "#20724E",
              fontWeight: "bold",
              borderRadius: "10px",
              border: "none",
              backgroundColor: "#E5F1EB",
              mr: 2,
              "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                border: "1px solid #E5F1EB",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="open">Open</MenuItem>
            <MenuItem value="close">Close</MenuItem>
            {/* <MenuItem value="in_progress">In-progress</MenuItem> */}
          </Select>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: "5px", mr: 2 }}
          >
            <Box
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => handleClick(event)}
              sx={{
                background: "#E5F1EB",
                borderRadius: "8px",
                width: "9rem",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <Typography sx={{ color: "#20724E", fontSize: "14px" }}>
                {startDate || moment().startOf("year").format("MMM DD, YYYY")}
              </Typography>
              <img src={CalanderActive} width="20" height="20" />
            </Box>
            <Typography
              sx={{ pr: 1, pl: 1, color: "#000000", fontWeight: "600" }}
            >
              To
            </Typography>
            <Box
              aria-controls={openEnd ? "basic-menu-end" : undefined}
              aria-haspopup="true"
              aria-expanded={openEnd ? "true" : undefined}
              onClick={(event) => handleClickEnd(event)}
              sx={{
                background: "#E5F1EB",
                borderRadius: "8px",
                width: "9rem",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <Typography sx={{ color: "#20724E", fontSize: "14px" }}>
                {endDate || moment().endOf("year").format("MMM DD, YYYY")}
              </Typography>
              <img src={CalanderActive} width="20" height="20" />
            </Box>
            {open && (
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <DateEditCalendar
                  handleCloseCalendar={handleClose}
                  saveTheDate={handleSaveDateStart}
                  date={startDate}
                />
              </Menu>
            )}
            {openEnd && (
              <Menu
                id="basic-menu-end"
                anchorEl={anchorElEnd}
                open={openEnd}
                onClose={handleCloseEnd}
              >
                <DateEditCalendar
                  handleCloseCalendar={handleCloseEnd}
                  saveTheDate={handleSaveDateEnd}
                />
              </Menu>
            )}
          </Box>
        </Box>
      </Box>
      <Divider />

      <Box sx={{ margin: "10px 25px 15px 20px" }}>
        <TableContainer
          sx={{
            maxHeight: "620px",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          {" "}
          {defectstData.length <= 0 ? (
            <Grid sx={{ paddingTop: "20px" }}>
              <Grid
                item
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box>
                  <Box
                    component="img"
                    sx={{
                      height: "25rem",
                      width: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    alt=""
                    src={noData}
                  />
                </Box>
                <Box
                  fontWeight="600"
                  sx={{ padding: "20px", fontWeight: "600" }}
                >
                  <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                    No Data Found
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {hasPermission(userData?.userRolePermission, "Edit_Defect") ||
                  hasPermission(userData?.userRolePermission, "View_Defect") ? (
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell>
                  ) : null}
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Defect ID
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Vessel Name
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Checklist ID
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Category Of Defect
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Department
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Created Date & Time
                  </TableCell>
                  {/* <TableCell
                  sx={{
                    color: "#B5B5C3",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  Submitted Date & time
                </TableCell> */}
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Closure Name
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Closure Date
                  </TableCell>
                </TableRow>
              </TableHead>
              {isLoading ? (
                <TableBody>
                  <TableRow
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      height: "10rem",
                    }}
                  >
                    <TableCell colSpan={10} align="center">
                      <CircularProgress color="success" />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {defectstData.map((row) => (
                    <TableRow
                      // key={row.DefectID}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      {hasPermission(
                        userData?.userRolePermission,
                        "Edit_Defect"
                      ) ||
                      hasPermission(
                        userData?.userRolePermission,
                        "View_Defect"
                      ) ? (
                        <TableCell align="left">
                          <Box sx={{ display: "flex" }}>
                            {hasPermission(
                              userData?.userRolePermission,
                              "Edit_Defect"
                            ) ? (
                              <IconButton
                                onClick={() => {
                                  navigate("/defects/editdefectdetails", {
                                    state: { DefectsRowData: row },
                                  });
                                }}
                              >
                                <img src={EditButton} width="30" height="30" />
                              </IconButton>
                            ) : null}

                            {hasPermission(
                              userData?.userRolePermission,
                              "View_Defect"
                            ) ? (
                              <IconButton
                                onClick={() => {
                                  navigate("/defects/viewdefectdetails", {
                                    state: { DefectsRowData: row?.id },
                                  });
                                }}
                              >
                                <img src={ViewButton} width="30" height="30" />
                              </IconButton>
                            ) : null}
                          </Box>
                        </TableCell>
                      ) : null}
                      <TableCell
                        sx={{
                          color: "#464E5F",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {GenerateDefectId(row?.vessel?.name, row?.display_id)}
                      </TableCell>
                      <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                        {row?.vessel?.name}
                      </TableCell>
                      <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                        {formatChecklistId(
                          row?.vessel?.name,
                          row?.checklist?.department?.name,
                          row?.checklist?.checklist_type?.name,
                          row?.check_list_type_info?.display_id
                        )}
                      </TableCell>
                      <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                        {row.category_defetct}
                      </TableCell>
                      <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                        {row?.checklist?.department?.name}
                      </TableCell>
                      <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                        {moment(row?.createdAt).local().format(
                          "D MMMM, YYYY | hh:mm A"
                        )}
                      </TableCell>
                      {/* <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                      {moment(row?.updatedAt)
                        .utc()
                        .format("D MMMM, YYYY | hh:mm A")}
                    </TableCell> */}
                      <TableCell align="center" sx={{ color: "#464E5F" }}>
                        <Box
                          sx={{
                            background:
                              row.defect_report_status === "open"
                                ? "#FFE2E5"
                                : "#E5F1EB",
                            color:
                              row.defect_report_status === "open"
                                ? "#FF4646"
                                : "#20704D",
                            border:
                              row.defect_report_status === "open"
                                ? "1px solid #FFE2E5"
                                : "1px solid #E5F1EB",
                            fontSize: "13px",
                            fontWeight: 600,
                            width: "6rem",
                            padding: "5px",
                            borderRadius: "6px",
                            font: "Poppins",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row.defect_report_status === "open"
                            ? "Open"
                            : "Closed"}
                        </Box>
                      </TableCell>

                      <TableCell sx={{ color: "#464E5F" }}>
                        {row?.closure_user_info === null
                          ? "-"
                          : row?.closure_user_info?.name}
                      </TableCell>
                      <TableCell sx={{ color: "#464E5F" }}>
                        {row?.closure_date === null
                          ? "-"
                          : moment(row?.closure_date)
                              .local()
                              .format("D MMMM, YYYY | hh:mm A")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
        <Divider />
        {defectstPaginationData?.totalRecord > TOTALLIMIT ? (
          <Stack
            spacing={2}
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            sx={{
              padding: "1rem",
              marginTop: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
              <Select
                value={isPaginationLimit}
                onChange={handleChangeIsPaginationLimit}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowDown}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                sx={{
                  height: "37px",
                  width: "6rem",
                  color: "#20724E",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: "#E5F1EB",
                  mr: 2,
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </Box>
            <Box>
              <Pagination
                count={defectstPaginationData?.totalPages}
                page={currentPage}
                onChange={handlePageChange}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{
                      previous: ArrowBackIcon,
                      next: ArrowForwardIcon,
                    }}
                    {...item}
                  />
                )}
              />
            </Box>
          </Stack>
        ) : null}
      </Box>
    </Paper>
  );
};

export default DefectsContent;
